/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import AppBar from '@material-ui/core/AppBar'
import { useQuery, useLazyQuery } from '@apollo/client'
import IconButton from '@material-ui/core/IconButton'
// import Button from '@material-ui/core/Button'
import Toolbar from '@material-ui/core/Toolbar'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Typography from '@material-ui/core/Typography'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import { navigate } from 'gatsby'
import Money from '../icons/Money'
// import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import PersonIcon from '@material-ui/icons/Person'
import HistoryIcon from '@material-ui/icons/History'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar'
import HelpIcon from '@material-ui/icons/Help'
import HomeIcon from '@material-ui/icons/Home'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import { GET_AUTH_COUNTRIES_STORAGE } from '../../graphql/queries/countrySelection'
import { GET_SELECTED_CONTACT } from '../../graphql/queries/user'

import commonStyles from '../../utils/commonStyles'
import { isValidNumber } from '../../utils/utils'

import {
  PARTNER_ROUTE,
  HISTORY_ROUTE,
  CREATE_PROFILE_ROUTE,
  LOGIN_ROUTE,
  CONTACTS_ROUTE,
  HELP_ROUTE,
  PROMOTIONS_ROUTE,
  MARKETPLACE_ROUTE,
} from '../../providers/routes'

import {
  GET_SELECT_WALLET,
  PARTNER_SCREEN_BY_PARTNER,
} from '../../graphql/queries/wallet'
import Logo from '../icons/logo-OKY-R'

function Header({ showCountrySelector }) {
  // let width = 50
  // let height = 40
  const useStyles = makeStyles(theme => ({
    MuiHeaderContainer: props => ({
      ...commonStyles.flexCentered,
      backgroundColor: theme.palette.common.white,
      height: props.showCountrySelector ? '68px' : '48px',

      '-moz-box-shadow': 'none',
      '-goog-ms-box-shadow': 'none',
      '-webkit-box-shadow': 'none',
      boxShadow: 'none',
    }),
    MuiMargin: {
      marginLeft: '20px',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '7px',
      },
    },
    MuiMarginRight: {
      textAlign: 'center',
      marginRight: '-10px',
    },
    Muitext: {
      textAlign: 'end',
    },
    MuiPrice: {
      fontSize: 14,
      width: 90,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    MuiPais: {
      '&.MuiAvatar-img': {
        width: '30px',
        height: '25px',
      },
    },
    topBarContainer: {
      maxHeight: '48px',
      height: '100%',
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      maxWidth: '550px',
    },
    toolbar: {
      padding: 0,
      width: '100%',
      height: '100%',
      ...commonStyles.flexCentered,
    },
    muyTextMenu: {
      color: '#ffff',
      fontSize: '20px',
      fontweight: '700',
    },
    muyIconMenu: {
      color: '#ffff',
      fontSize: '20px',
    },
    Swipeable: {
      '& .MuiPaper-root': {
        background: theme.palette.primary.main,
      },
    },
    MenuText: {
      color: theme.palette.primary.main,
      fontWeight: 600,
      marginLeft: '10px',
    },
    name: {
      color: theme.palette.primary.main,
      fontWeight: 600,
      marginLeft: '10px',
      width: 80,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    MuiImage: {
      width: '35px',
      marginTop: 5,
      [theme.breakpoints.down('sm')]: {
        width: '35px',
        alignSelf: 'center',
      },
    },
    dropdown: {
      position: 'absolute',
      top: '100%',
      left: 0,
      background: 'white',
      width: 200,
      boxShadow: '0 5px 6px rgba(0,0,0,0.2)',
    },
    dropdownTop: {
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #cbcbcb',
    },
    dropdownItem: {
      display: 'flex',
      alignItems: 'center',
      padding: 10,
      cursor: 'pointer',
    },
    supportToolbar: props => ({
      minHeight: props.showCountrySelector ? '65px' : '48px',
    }),
  }))

  const styles = useStyles({ showCountrySelector })
  // eslint-disable-next-line no-unused-vars
  const [partnerId, setPartnerId] = useState(null)

  const {
    data: { countrySelectedInfo },
  } = useQuery(GET_AUTH_COUNTRIES_STORAGE)
  const selectScreen = key => {
    if (key === '') {
      setMenuOpen(false)
    }
    if (key === 'Inicio') {
      navigate(PARTNER_ROUTE)
    }
    if (key === 'Historial') {
      navigate(HISTORY_ROUTE)
    }
    if (key === 'Perfil') {
      navigate(CREATE_PROFILE_ROUTE)
    }
    if (key === 'Contactos') {
      localStorage.setItem('fromHomeToContacts', 'true')
      navigate(CONTACTS_ROUTE)
    }
    if (key === 'Ayuda') {
      navigate(HELP_ROUTE)
    }
    if (key === 'Promociones') {
      navigate(PROMOTIONS_ROUTE)
    }
    if (key === 'Salir') {
      window.localStorage.clear()
      navigate(LOGIN_ROUTE)
    }
  }
  const goToMainPage = () => {
    if (selectedWallet) {
      navigate(MARKETPLACE_ROUTE)
    }
  }
  const goToHistory = () => {
    navigate(HISTORY_ROUTE)
  }

  const {
    data: { selectedWallet },
  } = useQuery(GET_SELECT_WALLET)

  const [getDataUser, dataUser] = useLazyQuery(PARTNER_SCREEN_BY_PARTNER, {
    variables: { partnerId: partnerId },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    if (isValidNumber(selectedWallet?.partnerId)) {
      setPartnerId(selectedWallet?.partnerId)
      getDataUser({
        variables: { partnerId: selectedWallet?.partnerId },
      })
    }
  }, [selectedWallet, partnerId])

  let option = [
    '',
    'Inicio',
    'Historial',
    'Contactos',
    'Perfil',
    'Ayuda',
    'Promociones',
    'Salir',
  ]
  if (!selectedWallet) {
    option = [
      '',
      'Inicio',
      'Contactos',
      'Perfil',
      'Ayuda',
      'Promociones',
      'Salir',
    ]
  }

  const [menuOpen, setMenuOpen] = useState(false)

  const RenderIcon = props => {
    if (props.isIconIn === '') {
      return <CloseIcon />
    } else if (props.isIconIn === 'Historial') {
      return <HistoryIcon />
    } else if (props.isIconIn === 'Inicio') {
      return <HomeIcon />
      } else if (props.isIconIn === 'Contactos') {
        return <PermContactCalendarIcon />
    } else if (props.isIconIn === 'Perfil') {
      return <PersonIcon />
    } else if (props.isIconIn === 'Ayuda') {
      return <HelpIcon />
    } else if (props.isIconIn === 'Promociones') {
      return <LocalOfferIcon />
    } else if (props.isIconIn === 'Salir') {
      return <ExitToAppIcon />
    }
  }

  var {
    data: { selectedContact },
  } = useQuery(GET_SELECTED_CONTACT)

  if (selectedContact === null && typeof window !== 'undefined') {
    const contact = window.localStorage?.getItem('contact')
    if (contact) {
      selectedContact = JSON.parse(contact)
    }
  }

  return (
    <React.Fragment>
      <AppBar
        position="fixed"
        className={styles.MuiHeaderContainer}
        id="app-header"
        aria-label="Main Header"
      >
        <Toolbar className={styles.toolbar}>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            className={styles.topBarContainer}
          >
            <Grid container item xs={12} sm={12} alignItems="center">
              <Grid item xs={4} sm={4}>
                <IconButton
                  edge="start"
                  color="primary"
                  aria-label="menu"
                  onClick={() => setMenuOpen(true)}
                >
                  <MenuIcon />
                </IconButton>

                <SwipeableDrawer
                  className={styles.Swipeable}
                  swipeAreaWidth={0}
                  anchor="left"
                  open={menuOpen}
                  onClose={() => setMenuOpen(false)}
                  onOpen={() => setMenuOpen(true)}
                >
                  <Divider />
                  <List>
                    {option.map((text, index) => (
                      <ListItem
                        onClick={() => selectScreen(text)}
                        button
                        key={text}
                      >
                        <ListItemIcon className={styles.muyIconMenu}>
                          <RenderIcon isIconIn={text} />
                        </ListItemIcon>
                        <ListItemText
                          className={styles.muyTextMenu}
                          primary={text}
                        />
                      </ListItem>
                    ))}
                  </List>
                </SwipeableDrawer>
              </Grid>

              <Grid
                item
                xs={4}
                sm={4}
                onClick={goToMainPage}
                container
                justifyContent="center"
                alignItems="center"
              >
                <Logo width={100} />
              </Grid>

              <Grid
                item
                xs={4}
                sm={4}
                container
                justify="flex-end"
                onClick={goToHistory}
              >
                <Grid className={styles.MuiMarginRight}>
                  {selectedWallet ? (
                    <>
                      <Money width={30} />
                      <Typography
                        className={styles.MuiPrice}
                        variant="h6"
                        component="h6"
                        color="primary"
                      >
                        {countrySelectedInfo?.countrySchema?.currencySymbol}{' '}
                        {dataUser?.data?.mainBalanceByUserAndPartner[0]?.mainBalance.toFixed(
                          2,
                        )}
                      </Typography>
                    </>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar className={styles.supportToolbar} />
    </React.Fragment>
  )
}

Header.defaultProps = {
  showCountrySelector: true,
}

export default Header
